import request from '@/utils/request'

export const signInGoogle = (idtoken, kkullanici, ksifre, eposta = '') => {
    const params = new URLSearchParams();
    params.append('idtoken', idtoken);
    params.append('kkullanici', kkullanici);
    params.append('ksifre', ksifre);
    params.append('eposta', eposta);
    return request({
        method: 'post',
        headers: {
            'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
        },
        url: 'Kisi/signin-google',
        params
    })
};

export const GenelRapor = () => {
    return request({
        method: 'post',
        url: 'Kisi/genel-rapor',
        params: {}
    })
};

export const SorumluOlunanKisileriGetir = () => {
    return request({
        url: 'Kisi/SorumluOlunanKisileriGetir',
    })
}

export const KisiyeKanaatEkle = (kisiId, metin) => {
    return request({
        url: 'Kisi/KisiyeKanaatEkle',
        params: {
            kisiId,
            metin
        }
    })
}


export const BelgeIste = (tur, tashihMi) => {
    return request({
        method: 'post',
        url: 'Kisi/belge-iste',
        params: {
            tur,
            tashihMi
        }
    })
};

export const TumKisiler = (karttaHicVazifeYapmayanlar = false, karttaDortHaftadirYapmayanlar = false) => {
    return request({
        url: 'Kisi/Kisiler',
        params : {
            karttaHicVazifeYapmayanlar,
            karttaDortHaftadirYapmayanlar
        }
    })
};

export const KarttaHicVazifeYapmayanKisileriGetir = () => {
    return request({
        url: 'Kisi/KarttaHicVazifeYapmayanKisileriGetir'
    })
}

export const KisiGetir = (id) => {
    return request({
        url: 'Kisi/Kisi?id=' + id
    })
};

export const KisiPost = (data, id) => {
    return request({
        url: 'Kisi/Kisi',
        method: 'post',
        data,
        params: {
            id
        }
    })
};

export const CikisYap = () => {
    return request({
        url: 'Kisi/Cikis'
    })
};